import React, { Component, PropTypes } from 'react';

let $ = window.jQuery;

export default class TextInputField extends Component {
    static propTypes = {
        val: PropTypes.string.isRequired,
        id: PropTypes.string.isRequired,
        label: PropTypes.string.isRequired,
        help: PropTypes.string.isRequired
    };

    state = {
        val: '',
        showHelp: 'none'
    };

    handleChange = (e) => {
        this.setState({
            val : e.target.value,
            showHelp: 'inline'
        });

        this.props.onChange(e);
    };

    componentDidMount() {
        this.setState({
            val: this.props.val
        });
        
        // mobile format
        if(this.props.mobileMask === true)
        {
            $('.mobileMask').inputmask("text", {
                mask: '(9999) 999-9999',
                autoUnmask: true,
                oncomplete : (e) => {
                    this.setState({
                        val: e.target.value,
                        showHelp: 'inline'
                    });

                    this.props.onChange(e);
                }
            });    
        }
        
    }

    componentWillReceiveProps(nextProps) {
        this.setState({
            val: nextProps.val
        });
    }

    shouldComponentUpdate(nextProps, nextState) {
        return true;
    }

    render() {
        let className = this.state.val ? 'form-control edited' : 'form-control';
        let hasError = '';

        if(this.props.hasError === true) {
            hasError = 'has-error';
        }

        if(this.props.mobileMask === true) // mobile format
        {
            className += ' mobileMask';
        }

        return (
            <div className={"form-group form-md-line-input "+hasError}>
                <input type="text" className={className} id={this.props.id}
                       onFocus={(e) => this.setState({showHelp: 'inline'})}
                       onBlur={(e) => this.setState({showHelp: 'none '})}
                       name={this.props.id}
                       onChange={this.handleChange}
                       value={this.state.val} />

                <label htmlFor={this.props.id}>{this.props.label}</label>
                <span className="help-block" style={{ display: this.state.showHelp }}>{this.props.help}</span>
            </div>
        )
    }
}


/** WEBPACK FOOTER **
 ** ./src/commons/Inputs/TextInputField.js
 **/